var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgVideoPlayer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5.87576C6.25 5.54166 6.25 5.37462 6.31982 5.28136C6.38066 5.20008 6.4738 5.14924 6.57507 5.142C6.69127 5.1337 6.83179 5.22404 7.11282 5.4047L8.76503 6.46684L10.4172 7.52897C10.6611 7.68575 10.783 7.76413 10.8252 7.8638C10.862 7.95089 10.862 8.04917 10.8252 8.13626C10.783 8.23593 10.6611 8.31432 10.4172 8.47109L8.76503 9.53323L7.11282 10.5954C6.83179 10.776 6.69127 10.8664 6.57507 10.8581C6.4738 10.8508 6.38066 10.8 6.31982 10.7187C6.25 10.6254 6.25 10.4584 6.25 10.1243V8.00003V5.87576Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    stroke: "#A4A4A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideoPlayer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/videoPlayer.3d994cd2.svg";
export { ForwardRef as ReactComponent };